import { useMemo } from "react";

export const processJsonString = (jsonString: string, errorMsg: string) => {
  const json = useMemo(() => {
    try {
      return JSON.parse(jsonString)
    } catch (e) {
      console.error(`Failed to parse JSON Payload: ${errorMsg}`)
      return null
    }
  }, [jsonString])

  return json
} 
